import React, { Component } from 'react';
import Container from 'react-bootstrap/Container'
import TopNavBar from '../../components/TopNavBar'
import SideNavBar from '../../components/SideNavBar'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import '../../stylesheets/sidenavbar.css'
import { toastr } from 'react-redux-toastr'
//https://www.freecodecamp.org/news/how-to-add-drag-and-drop-in-react-with-react-beautiful-dnd/
import { DragDropContext, Droppable, Draggable, resetServerContext } from 'react-beautiful-dnd';
import Form from 'react-bootstrap/Form'
import { MdDeleteForever } from 'react-icons/md';
import Button from 'react-bootstrap/Button'
import { BiSave } from 'react-icons/bi';
import Modal from 'react-bootstrap/Modal'
import InputGroup from 'react-bootstrap/InputGroup'
import FormControl from 'react-bootstrap/FormControl'

class ContentManagment extends Component {

    constructor(props) {
        super(props);

        this.state = {
            content: [],
            showHide: false,
            title: "",
            formData: null
        }
    }

    componentDidMount() {
        this.getContent()
    }

    getContent() {
        fetch(process.env.REACT_APP_API_URL + "content",
            {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('access_token')
                }
            }).then(response => response.json())
            .then(data => this.setState({ content: data }))
            .catch(error => {
                localStorage.clear();
                location.href = '/'
            });
    }

    handleOnDragEnd = result => {
        if (!result.destination) return;
        console.log(result)
        var array = this.state.content
        var id = result.draggableId
        var item = array.filter(x => x.id === id)

        var reOderItem = array.splice(result.source.index, 1)

        console.log(reOderItem[0])
        reOderItem[0].orderNumber = result.destination.index

        //Update
        fetch(process.env.REACT_APP_API_URL + "content/" + id, {
            method: "PUT",
            headers: {
                Authorization: "Bearer " + localStorage.getItem('access_token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(reOderItem[0])
        }).then(data => {
            return data.json()
        }).then(res => {
            array.splice(result.destination.index, 0, reOderItem[0])

            this.saveChanges(array)
            resetServerContext()

            toastr.success('Geupdate', 'Je hebt een content pagina geupdate')

        }).catch((error) => {
            console.error(error);
        });
    }

    handleModalShowHide() {
        this.setState({ showHide: !this.state.showHide })
    }

    saveChanges(array) {

        array.map((content, idx) => {
            content.orderNumber = idx
        })

        this.setState({ content: array });
    }

    addContent() {
        var array = this.state.content

        var formData = this.state.formData
        formData.append("title", this.state.title)
        formData.append("orderNumber", array.length)

        fetch(process.env.REACT_APP_API_URL + "content", {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem('access_token'),
                "role": "RW1wbG95ZWU="
            },
            body: formData
        }).then(data => {
            return data.json()
        })
            .then(result => {
                array.push(result)
                this.saveChanges(array)
                toastr.success('Content toegevoegd', 'Je hebt een nieuw content toegevoegd!')
            });
    }

    removeContent(id) {
        fetch(process.env.REACT_APP_API_URL + "content/" + id,
            {
                method: 'DELETE',
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('access_token'),
                    "role": "RW1wbG95ZWU="
                }
            }).then(response => response.json())
            .then(data => {
                if (data) {
                    var array = this.state.content
                    array = array.filter(x => x.id !== id)
                    this.setState({ content: array })

                    toastr.success('Content verwijderd', 'Je hebt een content verwijderd!')
                } else {
                    toastr.danger('Oeps!?', 'Er is iets misgegaan.')
                }
            })
            .catch(error => {
                localStorage.clear();
                location.href = '/'
            });
    }

    onChangeTitle = e => {
        var nam = e.target.name
        var val = e.target.value

        this.setState({ [nam]: val });

    }

    OnchangeUpdateTitle = e => {
        var id = e.target.id
        var val = e.target.value

        var array = this.state.content
        var idx = array.findIndex(x => x.id === id)

        array[idx].title = val;

        this.setState({ content: array })
    }

    onChangeFile = e => {
        var nam = e.target.name
        let file = e.target.files[0];
        const formData = new FormData();
        formData.append('file', file)

        this.setState({ [nam]: formData })
    }

    onClickUpdateTitle(id) {
        var array = this.state.content
        var obj = array.filter(x => x.id === id)[0]
        console.log(obj)
        fetch(process.env.REACT_APP_API_URL + "content/" + id, {
            method: "PUT",
            headers: {
                Authorization: "Bearer " + localStorage.getItem('access_token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(obj)
        }).then(data => {
            return data.json()
        }).then(result => {

            toastr.success('Geupdate', 'Je hebt een content pagina geupdate')

        }).catch((error) => {
            console.error(error);
        });
    }

    render() {
        const mystyle = {
            // backgroundColor: "lightgrey",
            padding: "10px",
            border: "1px solid gray",
            borderRadius: "10px"
        };

        const btnStyle = {
            cursor: "pointer"
        }

        return <Container fluid>
            <Row>
                <Col style={{ margin: "0px", padding: "0px" }}>
                    <TopNavBar />
                </Col>
            </Row>
            <Row className="h-100">
                <Col xs={1.8}>
                    <SideNavBar className='sidebar' />
                </Col>

                <Col>
                    {/* Here comes the content of the page */}
                    <h1>Content beheren</h1>
                    <Row>
                        <Col>
                            <Button onClick={() => this.handleModalShowHide()}>+</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <DragDropContext droppableId="characters" onDragEnd={this.handleOnDragEnd}>
                                <Droppable droppableId="characters">
                                    {(provided) => (
                                        <ul style={{ "list-style-type": "none", "padding-left": "0px" }} className="characters"  {...provided.droppableProps} ref={provided.innerRef}>
                                            {this.state.content.map((content, index) => {
                                                return (
                                                    <Draggable key={content.id} draggableId={content.id} index={index}>
                                                        {(provided) => (
                                                            <li style={{ "margin-left": "0px" }} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                <Row style={mystyle} className="m-2">
                                                                    <Col>
                                                                        <InputGroup className="mb-3">
                                                                            <InputGroup.Prepend style={btnStyle} onClick={() => this.onClickUpdateTitle(content.id)}>
                                                                                <InputGroup.Text id="basic-addon1"><BiSave /></InputGroup.Text>
                                                                            </InputGroup.Prepend>
                                                                            <FormControl
                                                                                id={content.id}
                                                                                value={content.title}
                                                                                aria-describedby="basic-addon1"
                                                                                onChange={this.OnchangeUpdateTitle}
                                                                            />
                                                                        </InputGroup>
                                                                    </Col>
                                                                    <Col>
                                                                        <MdDeleteForever className="float-right mt-3" style={btnStyle}  onClick={() => this.removeContent(content.id)} />
                                                                    </Col>
                                                                </Row>
                                                            </li>
                                                        )}
                                                    </Draggable>
                                                );
                                            })}
                                            {provided.placeholder}
                                        </ul>
                                    )}

                                </Droppable>
                            </DragDropContext>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Modal show={this.state.showHide}>
                <Modal.Header closeButton onClick={() => this.handleModalShowHide()}>
                    <Modal.Title>Content toevoegen</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formLoginName">
                            <Form.Label>Title</Form.Label>
                            <Form.Control type="text" placeholder="Jaarplanning" name="title" onChange={this.onChangeTitle} />
                        </Form.Group>

                        <Form.Group controlId="formfullName">
                            <Form.Label>Bestand toevoegen</Form.Label>
                            <Form.Control type="file" name="formData" onChange={this.onChangeFile} accept="application/pdf"/>
                        </Form.Group>
                    </Form>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.handleModalShowHide()}>
                        Sluit
                    </Button>
                    <Button variant="primary" onClick={() => this.addContent()}>
                        Opslaan
                    </Button>
                </Modal.Footer>
            </Modal>

        </Container>
    }
}

export default ContentManagment;